/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseScrollableTextFragment, ScrollableTextFragment, FullScrollableTextFragment} from '@amblique/contentful/app/contentful/fragments/scrollable-text';

/**
 * Get a single ScrollableText by ID (base - scalars only)
 */
export const getBaseScrollableTextById = gql`
  ${BaseScrollableTextFragment}

  query GetBaseScrollableTextById($id: String!, $locale: String!, $preview: Boolean) {
    scrollableText(id: $id, locale: $locale, preview: $preview) {
      ...BaseScrollableTextFragment
    }
  }
`;

/**
 * Get a single ScrollableText by ID (standard - 1 level deep)
 */
export const getScrollableTextById = gql`
  ${ScrollableTextFragment}

  query GetScrollableTextById($id: String!, $locale: String!, $preview: Boolean) {
    scrollableText(id: $id, locale: $locale, preview: $preview) {
      ...ScrollableTextFragment
    }
  }
`;

/**
 * Get a single ScrollableText by ID (full - 2 levels deep)
 */
export const getFullScrollableTextById = gql`
  ${FullScrollableTextFragment}

  query GetFullScrollableTextById($id: String!, $locale: String!, $preview: Boolean) {
    scrollableText(id: $id, locale: $locale, preview: $preview) {
      ...FullScrollableTextFragment
    }
  }
`;

/**
 * Get all ScrollableText entries with pagination (base - scalars only)
 */
export const getBaseScrollableTexts = gql`
  ${BaseScrollableTextFragment}

  query GetBaseScrollableTexts(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [ScrollableTextOrder]
    $where: ScrollableTextFilter
    $preview: Boolean
  ) {
    scrollableTextCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseScrollableTextFragment
      }
    }
  }
`;

/**
 * Get all ScrollableText entries with pagination (standard - 1 level deep)
 */
export const getScrollableTexts = gql`
  ${ScrollableTextFragment}

  query GetScrollableTexts(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [ScrollableTextOrder]
    $where: ScrollableTextFilter
    $preview: Boolean
  ) {
    scrollableTextCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...ScrollableTextFragment
      }
    }
  }
`;

/**
 * Get all ScrollableText entries with pagination (full - 2 levels deep)
 */
export const getFullScrollableTexts = gql`
  ${FullScrollableTextFragment}

  query GetFullScrollableTexts(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [ScrollableTextOrder]
    $where: ScrollableTextFilter
    $preview: Boolean
  ) {
    scrollableTextCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullScrollableTextFragment
      }
    }
  }
`;
